import { Component, Emit, Ref, Vue } from 'vue-property-decorator'
import BillingModalSelectionSearcherComponent from '@/modules/billing-module/components/modal/customer/selection/components/searcher/billing-modal-customer-selection-searcher.vue'
import BillingModalCustomerCreationComponent from '@/modules/billing-module/components/modal/customer/creation/billing-modal-customer-creation.vue'
import BillingModalCustomerCreation from '@/modules/billing-module/components/modal/customer/creation/billing-modal-customer-creation'
import {
    BillingModalCustomerSelectionParams,
    BillingModalCustomerSelectionState,
    initialBillingModalCustomerSelectionState
} from '@/modules/billing-module/components/modal/customer/selection/billing-modal-customer-selection.model'
import { BModal } from 'bootstrap-vue'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { SearcherStatus } from '@/components/common/searcher/shared/models/common-searcher.model'
import { IdentifierTypeResponse } from '@/api/resources/common/initialization/common-initialization.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { ModalUtils } from '@/shared/util/modal-utils'

@Component({
    components: {
        BillingModalSelectionSearcherComponent,
        BillingModalCustomerCreationComponent
    }
})
export default class BillingModalCustomerSelection extends Vue {
    @Ref() readonly customerSelectionModal!: BModal
    @Ref() readonly customerCreationModal!: BillingModalCustomerCreation

    @Emit()
    customerSelected(customer: CustomerResponse): CustomerResponse {
        return customer
    }

    state: BillingModalCustomerSelectionState
    constructor() {
        super()
        this.state = initialBillingModalCustomerSelectionState()
    }

    get visibleCustomerSelection(): boolean {
        return this.state.customers.length > 1
    }
    get identifierTypeName(): string {
        return this.state.identifierType?.name ?? ''
    }

    selectCustomer(customer: CustomerResponse): void {
        this.customerSelected(customer)
        this.hide()
    }

    onSearched(customers: CustomerResponse[]): void {
        this.state.customers = customers
        if (customers.length === 1) {
            this.selectCustomer(customers[0])
        }
    }
    onSearchStatusChanged(status: SearcherStatus): void {
        switch (status) {
        case SearcherStatus.ERROR:
            ModalUtils.showErrorModal(this.$tc('component.modalError.title'))
            break
        case SearcherStatus.NO_RESULTS:
            ModalUtils.showErrorModal(this.$tc('accounting.clientModal.searcher.noResults'))
            break
        case SearcherStatus.TOO_MANY_RESULTS:
            ModalUtils.showErrorModal(this.$tc('accounting.clientModal.searcher.tooManySearchResults'))
            break

        case SearcherStatus.INVALID_IDENTIFIER:
            this.state.customers = []
            ModalUtils.showErrorModal(this.$tc('component.searcher.error.validIdentifier'))
            break
        case SearcherStatus.SEARCH_CLEARED:
            this.state.customers = []
            break
        }
    }
    onIdentifierTypeChanged(identifierType: StrictNullable<IdentifierTypeResponse>): void {
        this.state.identifierType = identifierType
    }

    show(params: BillingModalCustomerSelectionParams): void {
        const { patient } = params
        this.state = {
            ...initialBillingModalCustomerSelectionState(),
            patient
        }
        this.customerSelectionModal.show()
    }
    hide(): void {
        this.customerSelectionModal.hide()
    }

    showNewClientModal(): void {
        const { patient } = this.state
        if (patient) {
            this.customerCreationModal.show({ patient })
        }
    }
}
